import SelectorEngine from '../../utils/dom/selector-engine';

class LockedArticle {
	constructor() {
		this.wrapper = SelectorEngine.findOne('.p-exclusive-content-page');

		if (this.wrapper) {
			this.initEvents();
		}
	}

	initEvents() {

		if (this.wrapper.classList.contains('isLocked')) {
			let maxHeight = 10;
			const loginWrapper = SelectorEngine.findOne('.p-exclusive-content-page__locked-banner', this.wrapper);
			const imageVideoBlock = SelectorEngine.findOne('.p-exclusive-content-page__image-video-block', this.wrapper)  ;
			let isAdjustingScroll = false;

			if (this.wrapper.classList.contains('isCoachArea')) {
				maxHeight = 15;
			}

			if (imageVideoBlock.classList.contains('isVideo')) {
				// if the article is a video article we are disabling the video button.
				const video = SelectorEngine.findOne('.lta-video-embed');
				video.classList.add('disable-video-btn');
			}

			window.addEventListener('scroll', function () {
				const scrollPosition = window.scrollY;
				const documentHeight = document.documentElement.scrollHeight - window.innerHeight;
				const scrollPercentage = (scrollPosition / documentHeight) * 100;

				if (!isAdjustingScroll && scrollPercentage > maxHeight) {
					loginWrapper.classList.add('is-visible');
					isAdjustingScroll = true;
					window.scrollTo(0, 0);
					setTimeout(function () {
						isAdjustingScroll = false;
					}, 200); // Adjust this delay as needed to prevent flickering
				}
			});
		}
	}
}

const globalMyResources = new LockedArticle();
export default globalMyResources;
